module.exports = __webpack_public_path__ + "img/logo-white.9226a72b.png";